module.exports = __webpack_public_path__ + "img/正在生成.671be98c.svg";